import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import { CommonModule } from '@angular/common';
import {ApplicantInformationComponent} from "./components/applicant-information/applicant-information.component";
import {ValidatorDashboardComponent} from "./components/validator-dashboard/validator-dashboard.component";
import {InfoTramiteComponent} from "./components/info-tramite/info-tramite.component";
import {ValidationResultComponent} from "./components/validation-result/validation-result.component";
import {FieldsActionComponent} from "./components/fields-action/fields-action.component";
import {DocumentUserComponent} from "./components/document-user/document-user.component";
import {VisitInfoComponent} from "./components/visit-info/visit-info.component";
import {AuditComponent} from "./components/audit/audit.component";
import {SharedModule} from "../../shared/shared.module";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {MatNativeDateModule} from "@angular/material/core";
import {MatInputModule} from "@angular/material/input";
import {DemoNgZorroAntdModule} from "../../core/modules/ng-antd.module";
import {PdfViewerModule} from "ng2-pdf-viewer";
import {MatTableModule} from "@angular/material/table";
import {NgxPaginationModule} from "ngx-pagination";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {MatPaginatorModule} from "@angular/material/paginator";
import {MatSortModule} from "@angular/material/sort";
import {RequestModule} from "../request/request.module";



@NgModule({
  declarations: [
    ApplicantInformationComponent,
    ValidatorDashboardComponent,
    InfoTramiteComponent,
    ValidationResultComponent,
    FieldsActionComponent,
    DocumentUserComponent,
    VisitInfoComponent,
    AuditComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    RequestModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatInputModule,
    DemoNgZorroAntdModule,
    PdfViewerModule,
    FormsModule,
    MatTableModule,
    NgxPaginationModule,
    NgbModule,
    MatPaginatorModule,
    MatSortModule
  ],
    exports: [
        InfoTramiteComponent,
        AuditComponent
    ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class TrackingModule { }
